import { getAttrMarkup, setChildAttrs, clearChildAttrs, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_composite');

register('wm-composite', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmComposite wmsTransclude wmCaptionPosition ${getAttrMarkup(attrs)}
                [ngClass]="{\'caption-left\': captionposition == \'left\',\'caption-floating\': captionposition == \'floating\',\'caption-right\': captionposition == \'right\',\'caption-top\': captionposition == \'top\'}">`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
